<template>
  <!-- 套餐 -->
  <div class="package">
    <div class="top_center">
      <div class="bread w100 flex sz12 mb10">
        <div class="cursor" @click="gosinfo">
          <i class="el-icon-arrow-left"></i>个人中心
        </div>
        <div v-if="!buyType" class="cursor" @click="gopages">
          <i class="el-icon-arrow-left"></i>套餐详情
        </div>
      </div>
      <div class="w100">
        <div class="sz30 font_bo mb10">订单信息 &nbsp;&nbsp;<span class="sz12 co70" style="font-weight: 400;">*如需其他套餐，您可以点击左上角返回上级菜单</span></div>
        <div class="w100 baff details">
          <div class="mb20 flex alcen">
            <div class="font_bo">购买会员：</div>
            <div style="line-height: 24px;" v-if="plhons">
              <span>{{details.mealNameZh}}</span>
            </div>
            <div style="line-height: 24px;" v-else>
              <span v-if="buyType == 1">{{details.mealNameZh}}</span>
              <el-select v-else v-model="valuetwo" :disabled="disabledtwo" placeholder="请选择" @change="selectchangetwo">
                <el-option v-for="item in optionstwo" :key="item.key" :label="item.value" :value="item.key">
                </el-option>
              </el-select>
            </div>

          </div>
          <div class="mb20 flex alcen">
            <div class="font_bo">购买时长：</div>
            <div style="line-height: 24px;" v-if="plhons">
              <span>{{details.mealAddFormmat}}度</span>
            </div>
            <div style="line-height: 24px;" v-else>
              <span v-if="buyType == 2">{{details.mealAddFormmat}}度</span>
              <el-select v-else v-model="value" :disabled="disabled" placeholder="请选择" @change="selectchange">
                <el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="mb20 flex">
            <div class="contain font_bo">订阅包含：</div>
            <div class="contain_p" :class="openstuts?'con_p':'con_b' ">
              <p v-for="(item,index2) in details.mealDesc" :key="index2">{{item}}</p>
              <p v-show="openstuts" class="iconfont cursor" @click="coopen">展开 <i class="el-icon-caret-right"></i></p>
              <p v-show="!openstuts" class="iconfont cursor" @click="coopen">收起 <i class="el-icon-caret-bottom"></i></p>
            </div>
          </div>
          <div class="mb20 flex alcen">
            <div class="font_bo minw120">会员有效期至 : </div>
            <div style="line-height: 24px;"> {{details.endDate}}</div>
          </div>
          <div class="mb20 flex alcen">
            <div class="font_bo">折扣码 : </div>
            <div>&nbsp;<input type="text" v-model="discountCode" @blur="onBlur"><span class="ef38 dib ml10" v-if="dsiscount">* 无效折扣码</span></div>
          </div>
          <div class="mb20">
            <span class="font_bo">支付方式： </span>
          </div>
          <div class="w100 zfimg flex alcen">
            <div class="flex h100 alcen mr10 cursor" @click="paymode(1)">
              <div class="qq ru50 flex">
                <p v-if="paymentmed == 1" class="ru50 ba6e"></p>
              </div>
              <div class="imhgs">
                <img src="@/assets/img/home/wx.png" alt="">
              </div>
            </div>
            <div class="flex h100 alcen cursor" @click="paymode(2)">
              <div class="qq ru50 flex mr5">
                <p v-if="paymentmed == 2" class="ru50 ba6e"></p>
              </div>
              <div class="imhgs sz18">
                对公转账
              </div>
            </div>
          </div>
          <div class="mb20 w100 font_bo flex" v-if="details.oldPrice">
            <div class="w50">原价：</div>
            <div class="w50 right sz20">¥{{details.oldPrice}}</div>
          </div>
          <div class="mb20 w100 flex" v-if="details.discountAmount">
            <div class="w50">折扣优惠</div>
            <div class="font_bo w50 right ef38 sz20">- {{details.discountAmount}}</div>
          </div>
          <div class="mb20 w100 flex" v-if="details.youhuiPrice">
            <div class="w50">套餐减免</div>
            <div class="font_bo w50 right ef38 sz20">- {{details.youhuiPrice}}</div>
          </div>
          <div class="flex amount mb30">
            <p class="font_bo">支付金额：</p>
            <p class="sz30 font_bo right">¥{{details.price}}</p>
          </div>
          <div class="w100 flex submit_top">
            <div class="sumbit coff ba6e ru5 sz16 center cursor" @click="submit">前往支付</div>
          </div>
        </div>
        <div class="agreement w100 flex">
          <div v-if="agreementstuts" class="correct ru5" @click="clagreement"></div>
          <div v-else class="corrects ru5" @click="clagreement"></div>
          <div class="sz16 cursor" @click="policy">我已阅读并同意《用户协议》</div>
          <div v-if="agrestuts" class="co6e">* 请先勾选《用户协议》</div>
        </div>
      </div>

    </div>
    <div v-if="dialogVisible" class="dialogqr">
      <div class="qrcode">
        <i class="el-icon-close cursor" @click="closesni"></i>
        <div class="codeimg">
          <VueQr :margin='8' :size='280' :whiteMargin="true" :logoMargin="3" :logoCornerRadius="20" :text='codeText'> </VueQr>
          <div class="refresh cursor" v-if="time == 0" @click="refqrcode">
            <div class="refresh_top center">
              <img src="@/assets/img/home/sx.png" alt="">
              <div class="coff mt20">二维码失效 点击重试</div>
            </div>
          </div>
          <div class="w100 mt20" v-if="time != 0">
            <p class="w100 center sz12">请使用微信扫码支付，过期后请重新</p>
            <p class="w100 center sz12">获取二维码。二维码到期倒计时 <span>{{cont}}</span>秒</p>
          </div>
        </div>
      </div>
    </div>
    <div class="title_top" v-if="dialogVisiblesher">
      <div class="nologins_title">
        <div style="text-align: right;" class="nologins_title_icon">
          <i class="el-icon-close cursor" @click="dialogVisibleTwos"></i>
        </div>
        <div class="nologins_title_imgs">
          <img src="@/assets/img/home/kf2.png" alt="">
        </div>
        <div style="font-size:16px;" class="nologins_title_text center sz12 mt20">
          联系客服
        </div>
      </div>
    </div>
    <!-- <icp></icp> -->
  </div>
</template>
    <script> 
import { SETMEALS, QRCODEURL, QUERYORDER, SETMEALSDETAIL, SETMEALSDETAILCONTINUE } from '../../api/payment'
import VueQr from 'vue-qr'
import icp from '../icp/icp.vue'
export default {
  components: { VueQr,icp },
  data() {
    return {
      tabstuts: 1,
      agreementstuts: false,
      agrestuts: false,
      mealId: '',
      codeText: '',
      dialogVisible: false,
      codeTimer: null,//定时器
      codeTime: 20, // 限制1分钟后没请求到erp数据，不再继续请求
      cont: '',
      time: 60,
      liststuts: false,
      avtivets: 2,
      viplist: [],
      url: process.env.VUE_APP_BASE_API,
      activeName: '1',
      details: {},
      mealType: this.$route.query.code,
      buyType: this.$route.query.type,
      plhons: this.$route.query.plhons,
      discountCode: '',
      dsiscount: false,
      options: [],
      optionstwo: [],
      value: '', // 升级选择
      valuetwo: '',//  续费选择
      mealTypetwo: '',
      disabled: false,
      disabledtwo: false,
      openstuts: true,
      paymentmed: 1, //支付方式
      dialogVisiblesher: false,
      arrpay:[]
    }
  },
  mounted() {
    if (this.$route.query.type) {
      this.renews()
      if (this.$route.query.typ = 1) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    } else {
      this.submits()
    }
  },
  computed: {
  },
  watch: {
    'agreementstuts': function (newVal, oldVal) {
      if (!oldVal) {
        this.agrestuts = false
      }
    },
  },
  methods: {
    submits() {
      let data = {
        mealType: this.mealType,
        discountCode: this.discountCode
      }
      SETMEALSDETAIL(data).then(res => {
        if (res.data.code == 'error') {
          this.$message({
            showClose: true,
            duration: 4000,
            message: res.data.msg,
            type: 'error'
          });
          this.$router.push({ path: './demo', query: { r: 6 } })
        } else {
          this.details = res.data.body
          this.mealId = res.data.body.id
          if (!res.data.body.discountAmount && this.discountCode) {
            this.dsiscount = true
          } else {
            this.dsiscount = false
          }
        }
      })
    },
    // 续费
    renews() {
      SETMEALSDETAILCONTINUE({ buyType: this.buyType, discountCode: this.discountCode }).then(res => {
        this.details = res.data.body
        this.mealId = res.data.body.id

        if (this.buyType == 1) { // 续费
          if (res.data.body.xufeiList.length) {
            SETMEALSDETAILCONTINUE({ mealType: res.data.body.xufeiList[0].key, buyType: this.buyType, discountCode: this.discountCode }).then(rem => {
              this.options = rem.data.body.xufeiList
              this.value = rem.data.body.xufeiList[0].value
              this.details = rem.data.body
              this.mealId = rem.data.body.id
              this.mealType = rem.data.body.mealType
            })
          }
        } else { // 升级
          if (res.data.body.shengjiList) {
            this.optionstwo = res.data.body.shengjiList
            this.valuetwo = res.data.body.shengjiList[0].value
          }
          SETMEALSDETAILCONTINUE({ mealType: res.data.body.shengjiList[0].key, buyType: this.buyType, discountCode: this.discountCode }).then(rer => {
            this.details = rer.data.body
            this.mealId = rer.data.body.id
            this.mealType = rer.data.body.mealType
          })
        }

      })
    },
    // 选择时长
    selectchange(e) {
      this.mealType = e
      SETMEALSDETAILCONTINUE({ mealType: e, buyType: this.buyType, discountCode: this.discountCode }).then(res => {
        this.options = res.data.body.xufeiList
        this.details = res.data.body
        this.mealId = res.data.body.id
      })
    },
    // 选择套餐
    selectchangetwo(e) {
      SETMEALSDETAILCONTINUE({ mealType: e, buyType: this.buyType, discountCode: this.discountCode }).then(res => {
        this.options = res.data.body.xufeiList
        this.details = res.data.body
        this.mealId = res.data.body.id
      })
    },
    // 折扣码
    onBlur() {
      if (this.$route.query.type) {
        SETMEALSDETAILCONTINUE({ mealType: this.mealType, buyType: this.buyType, discountCode: this.discountCode }).then(res => {
          this.options = res.data.body.xufeiList
          this.details = res.data.body
          this.mealId = res.data.body.id
        })
      } else {
        this.submits()
      }
      window._hmt.push(["_trackEvent", "action", "折扣码", "click", "couponLook", this.discountCode]);
    },
    // 清除从官网带过来的参数
    gosinfo() {
      if (this.url == '/dev') {
        window.open('http://localhost:8080/#/info', '_parent',)
      } else if (this.url == '/prod') {
        window.open('https://aff.foshobrands.com/#/info', '_parent',)
      } else if (this.url == '/test') {
        window.open('https://sit-aff.foshobrands.com/#/info', '_parent',)
      }
    },
    gopages() {
      if (this.url == '/dev') {
        window.open('http://localhost:8080/#/package', '_parent',)
      } else if (this.url == '/prod') {
        window.open('https://aff.foshobrands.com/#/package', '_parent',)
      } else if (this.url == '/test') {
        window.open('https://sit-aff.foshobrands.com/#/package', '_parent',)
      }
    },
    clagreement() {
      this.agreementstuts = !this.agreementstuts
    },
    refqrcode() {
      this.time = 60
      this.submit()
    },
    submit() {
      this.codeTime = 20
      if (!this.agreementstuts) {
        this.agrestuts = true
      } else {
        this.agrestuts = false
        let data = {
          buyType: this.buyType, // 1续费 2升级
          mealId: this.mealId,
          discountCode: this.discountCode
        }
        QRCODEURL(data).then(res => {
          if (res.data.code == 'success') {
            this.codeText = res.data.body.code_url
            this.arrpay.push(res.data.body.orderNo)
            this.dialogVisible = true
            this.cont = this.time
            this.timeFun = setInterval(() => {
              --this.time;
              this.cont = this.time;
              if (this.time == 0) {
                this.cont = "0";
                clearInterval(this.timeFun);
              }
            }, 1000);
            this.arrpay.forEach(item => {
              this.codeTimer = window.setInterval(() => {
                if (this.codeTime <= 0) {
                  window.clearInterval(this.codeTimer);
                  this.codeTimer = null;
                  this.codeTime = 0;
                } else {
                  QUERYORDER({ orderNo: item }).then(res => {
                    if (res.data.code == 'success') {
                      this.dialogVisible = false
                      window.clearInterval(this.codeTimer);
                      this.codeTimer = null;
                      this.codeTime = 0;
                      this.$message({
                        message: '支付成功',
                        type: 'success'
                      });
                      this.arrpay = []
                      window._hmt.push(["_trackEvent", "action", "下单", "click", item]);
                      this.$router.push({ path: './demo', query: { r: 6 } })
                    } else {
                      this.codeTime--;
                      return
                    }
                  })
                }
              }, 2000);
            })

          }
        })
      }
    },
    /**
    * policy()
    * 隐私政策
    */
    policy() {
      let routeUrl = this.$router.resolve({
        path: "/influencers",
      });
      window.open(routeUrl.href, '_blank');
      this.iconstuts = true
    },
    closesni() {
      this.dialogVisible = false
      window.clearInterval(this.codeTimer);
      window.clearInterval(this.timeFun);
      this.codeTimer = null;
      this.codeTime = 0;
      this.time = 60
    },
    // 展开收起
    coopen() {
      this.openstuts = !this.openstuts
    },
    // 选择支付方式
    paymode(e) {
      this.paymentmed = e
      if (e == 2) {
        this.dialogVisiblesher = true
      }
    },
    dialogVisibleTwos() {
      this.paymentmed = 1
      this.dialogVisiblesher = false
    },
  }
}
  </script>
      
  <style lang="less" scoped>
.package {
  padding-left: 20Px;
  padding-top: 69px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background: #fafafd;
}
@media screen and (min-width: 1000px) and (max-width: 2000px) {
  .top_center {
    width: 1600px;
    margin: 0 auto;
  }
  .listitem {
    min-height: 470px;
  }
}
@media screen and (min-width: 2000px) and (max-width: 3000px) {
  .top_center {
    width: 1920px;
    margin: 0 auto;
  }
  .listitem {
    min-height: 600px;
  }
}
.top_center {
  padding: 20px 0;
  height: 100vh;
  position: relative;
  .bread {
    height: 20px;
    align-items: center;
    div {
      margin-right: 10px;
    }
  }
  .details {
    padding: 24px 22px 16px 22px;
    .contain {
      min-width: 85px;
      margin-right: 10px;
    }
    .contain_p {
      width: 300px;
      p {
        margin-bottom: 16px;
      }
      .iconfont {
        position: absolute;
        right: 0;
        top: 0;
      }
    }
    .con_p {
      height: 30px;
      overflow: hidden;
      position: relative;
    }
    .con_b {
      position: relative;
      height: auto;
    }
    .zfimg {
      height: 60px;
      align-items: center;
      .qq {
        width: 14px;
        height: 14px;
        justify-content: center;
        align-items: center;
        border: 1px solid #be3c6e;
        p {
          width: 8px;
          height: 8px;
        }
      }
      .imhgs {
        height: 60px;
        line-height: 58px;
        img {
          height: 60px;
        }
      }
    }
    .amount {
      height: 60px;
      align-items: center;
      justify-content: space-between;
      border-top: 1px solid rgba(166, 168, 191, 0.25);
      padding-bottom: 10px;
    }
    .submit_top {
      justify-content: flex-end;
      .sumbit {
        width: 97px;
        height: 40px;
        line-height: 40px;
        margin: 16px 10px 0 0;
      }
    }
    input {
      height: 25px;
      width: 250px;
    }
  }
  .agreement {
    height: 60px;
    align-items: center;
    justify-content: flex-end;
    .correct {
      width: 25px;
      height: 25px;
      line-height: 20px;
      border: 2px solid #000;
      position: relative;
      cursor: pointer;
      margin-right: 10px;
    }
    .corrects {
      width: 25px;
      height: 25px;
      line-height: 20px;
      border: 2px solid #000;
      position: relative;
      cursor: pointer;
      margin-right: 10px;
    }

    .correct::before {
      position: absolute;
      content: " ";
      width: 7px;
      height: 13px;
      transform: rotate(45deg);
      border-right: 2px solid #000;
      border-bottom: 2px solid #000;
      top: 1px;
      left: 6px;
    }
  }
}
.dialogqr {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 11111;
  .qrcode {
    padding: 40px;
    background: #fff;
    position: relative;
    .codeimg {
      width: 100%;
      position: relative;
      .refresh {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.9);
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 120px;
          height: 120px;
          margin: 0 auto;
        }
      }
      span {
        color: #ef3826;
      }
    }
    i {
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }
}
.ef38 {
  color: #ef3826;
}
.title_top {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5, #000);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
}
.nologins_title {
  width: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -200px;
  margin-left: -200px;
  background: #fff;
  border-radius: 15px;
  padding: 20px;
}
.nologins_title_imgs {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  margin-top: 10px;
  img {
    width: 200px;
    height: 200px;
    display: inline-block;
    margin: 0 auto;
  }
}
</style>
  <style lang="less">
.el-collapse-item__header {
  font-weight: bold;
  font-size: 18px;
  background: none;
  height: 90px;
}
.el-collapse-item__wrap {
  background: none;
  font-size: 16px;
  color: #000;
}
.el-icon-arrow-right:before {
  content: "\e791";
}
.package {
  .el-select {
    height: 31px;
  }
  // .el-icon-arrow-up:before{
  //   content: "\e792";
  // }
  .el-input__icon {
    width: 100%;
    height: 100%;
    line-height: 31px;
  }
}
</style>